export enum RegistrationQuestionType {
  TextBox = 1,
  DropDown = 2,
  MultiSelect = 3,
  Radio = 4,
  Checkbox = 5
}
